Vivense.init['product'] = Vivense.init['product'] || [];

window.viveProductPage = window.viveProductPage || {};

Vivense.init['product'].push(function() {
    
    var addToCartBtn = $(".add-to-cart-btn");
    var addToCartForm = $(".add-to-cart-form");
    var salePrice = $(".new-price");
    var delPrice = $(".del-price");
    var deliveryDate = $(".delivery-date");

    window.viveProductPage.addToCart=function(cartForm){

        $.ajaxSetup({ cache: false });

        var datas = cartForm.serialize();

        $.getJSON('/index.php?option=com_virtuemart&nosef=1&view=cart&task=addJS&format=json',encodeURIComponent(datas),
            function(datas, textStatus) {
                if(datas.stat ==1){

                    window.location='/siparis-listesi.html';

                } else if(datas.stat ==2){

                    var value = cartForm.find('.quantity-input').val() ;
                    var txt = cartForm.find(".pname").val();

                    $.jAlert({
                        'title': '&nbsp;',
                        'content': '<span class="product-alert-text">'+datas.msg+'</span>',
                        'theme': 'default',
                        'size': 'sm',
                        'showAnimation': 'fadeIn',
                        'hideAnimation': 'fadeOut',
                        'btns':  [ {'text': 'KAPAT','id':'cancel-id'}]
                    });


                } else {
                    $.jAlert({
                        'title': '&nbsp;',
                        'content': '<span class="product-alert-text">'+datas.msg+'</span>',
                        'theme': 'default',
                        'size': 'sm',
                        'showAnimation': 'fadeIn',
                        'hideAnimation': 'fadeOut',
                        'btns':  [ {'text': 'KAPAT','id':'cancel-id'}]
                    });
                }

                addToCartBtn.html('SEPETE EKLE');
            });

        $.ajaxSetup({ cache: true });

    };

    window.viveProductPage.addToCartClickEvent=function(){

        var selectedVariant = '';
        var price = $(".new-price").data('value');

        if($(".active-size-box").length){
            var chosenVariantElement = $(".active-size-box").parent();
            selectedVariant = chosenVariantElement.data('variantvalue');
            price =  parseInt(chosenVariantElement.data('price'));
        }
        else if($("#form_components_sales_price").length){
            price = parseInt($("#form_components_sales_price").val());
        }

        dataLayer.push({
            'event': 'addToCart',
            'ecommerce': {
                'currencyCode': 'TRY',
                'add': {
                    'products': [{
                        'name': parseInt($(".pname").val()),
                        'id' : $(".product-sku").data("sku"),
                        'price': price,
                        'brand': 'Vivense',
                        'category': $("#breadcrumb-ol li:nth-last-child(2)").children().text(),
                        'variant': selectedVariant,
                        'quantity': 1
                    }]
                }
            }
        });

    };

    window.viveProductPage.setPopOverContent = function(sum){
        var popOverContent = $(".popover-content");
        var componentPriceTable = $('.product-price-details');
        var orangeText = componentPriceTable.find('.orange-text');

        if(sum < 1500){

            popOverContent.children().text("1500 TL altı ürünlerin kurulumu müşteriye aittir.");
            popOverContent.css("width","170px");
            popOverContent.children().css("width","156px");
            var newTopOffset = orangeText.offset().top - ($(".popover-content").outerHeight()/2) + (orangeText.outerHeight()/2);
            $(".popover-product-details").offset({top:newTopOffset});

        }
        else{

            popOverContent.children().text("Bu takımın içeriğini değiştirebilirsin.");
            popOverContent.css("width","");
            var newTopOffset = orangeText.offset().top - (popOverContent.outerHeight()/2) + (orangeText.outerHeight()/2);
            $(".popover-product-details").offset({top:newTopOffset});

        }

    };

    window.viveProductPage.calculateComponentPrice = function(){

        var componentSelectBoxes = $(".component-edit-select");
        var sum = 0;

        componentSelectBoxes.each(function() {

            var selectBox = $(this);

            var componentAdded = $("#form_product_component"+selectBox.data('component')+"_checked");

            if(componentAdded.val() == 1){

                var componentSumTd = $(".component-edit-sumPrice-"+selectBox.data('component'));

                componentSumTd.html((selectBox.val()*componentSumTd.data('piece-price')).toLocaleString()+" TL");

                var componentCartPrice = $(".component-price-"+selectBox.data('component'));
                componentCartPrice.html(selectBox.val()+" x "+componentSumTd.data('piece-price').toLocaleString()+" TL");

                $("#form_product_component"+selectBox.data('component')+"_count").val(selectBox.val());

                sum += selectBox.val()*componentSumTd.data('piece-price');
            }

        });

        window.viveProductPage.setPopOverContent(sum);

        $(".component-sumPrice").html(sum.toLocaleString()+" TL");

        salePrice.html(sum.toLocaleString()+" TL");

        delPrice.html((parseInt(sum*delPrice.data('value')/salePrice.data('value'))).toLocaleString()+" TL");

        $("#form_components_sales_price").val(sum);
    };



    $(".variant-div").click(function () {

        var chosendiv = $(this);
        var chosen = chosendiv.parent();
        var span = $(".variant-span");

        span.html("Seçiminiz: "+chosen.data('variantvalue'));
        salePrice.html(parseInt(chosen.data('price')).toLocaleString()+" TL");
        delPrice.html(parseInt(chosen.data('price')*delPrice.data('value')/salePrice.data('value')).toLocaleString()+" TL");
        $("#customPrice0127").val(chosen.data('customfield'));

        if(chosen.data('deliverydate') != ''){
            deliveryDate.html(chosen.data('deliverydate'));
        }
        if(chosen.data('images') != ''){
            $("#media_"+chosen.data('images')).click();

        }

    });

    $(".video_icon").click(function () {

        var id = $(this).attr("href").slice(1);

        $("."+id).click();

    });

    addToCartBtn.click(function () {

        addToCartBtn.html('<i class="fa fa-spinner fa-spin" style="font-size:24px"></i>');

        window.viveProductPage.addToCartClickEvent();

        window.viveProductPage.addToCart(addToCartForm);

    });



    $(".component-edit-select").change(function () {


        window.viveProductPage.calculateComponentPrice();

    });


    $('body').on('click', ".component-add-button", function(){

        var added = $(this);


        $("#form_product_component"+added.data("component")+"_checked").val(1);

        window.viveProductPage.calculateComponentPrice();

        added.css("display","none");

        $(".component-select-"+added.data("component")).css("display","");

        $(".component-"+added.data("component")).css("display","");

        $(".minus-"+added.data("component")).css("display","");

    });


    $(".component-edit-minus").click(function(){

        var componentSelectBoxes = $(".component-edit-select");

        var addedComponentCount = 0;

        componentSelectBoxes.each(function() {

            var selectBox = $(this);

            var componentAdded = $("#form_product_component"+selectBox.data('component')+"_checked");

            if(componentAdded.val() == 1){
                addedComponentCount++;
            }

        });
        
        if(addedComponentCount > 1){
            var deleted = $(this);

            deleted.css("display","none");

            $("#form_product_component"+deleted.data("component")+"_checked").val(0);
            $("#form_product_component"+deleted.data('component')+"_count").val(0);

            var componentEditPrice = $(".component-edit-sumPrice-"+deleted.data("component"));
            componentEditPrice.html('<hr class="none-component">');

            $(".component-select-"+deleted.data("component")).css("display","none");

            $(".add-button-"+deleted.data("component")).css("display","");

            $(".component-"+deleted.data("component")).css("display","none");

            window.viveProductPage.calculateComponentPrice();
        }


    });


    $(".ask-question-button").click(function(e){

        e.preventDefault();

        var name = $("#ask-question-name");
        var product = $(".product-name");
        var productName = product.data("pname");
        var productsku = product.data("sku");
        var email = $("#ask-question-email");
        var question = $("#question-text");

        var modalHtml = "<p><strong>Ad Soyad:</strong> "+name.val()+"</p>";
        modalHtml+= "<p><strong>E-Posta Adresi:</strong> "+email.val()+"</p>";
        modalHtml+= "<p><strong>Ürün:</strong> "+productName+"</p>";
        modalHtml+= "<p><strong>Soru:</strong> "+question.val()+"</p>";

        $(".question-sended-modal-ended").html(modalHtml);

        $.ajax('/ajax/mail/ask_question.php', {
            method: 'POST',
            data: 'task=sendMail&email='+email.val()+"&pname="+productName+"&sku="+productsku+"&name="+name.val()+"&question="+question.val()
        })
        .done(function (data, textStatus, jqXHR) {
            console.log(data);
            response = JSON.parse(data);

            $(".ask-question-modal").modal('hide');



            $(".question-sended-modal").modal();

        })
        .fail();

    });

    $(".open-ask-question-modal").click(function(e){

        $.ajax('/ajax/mail/ask_question.php', {
            method: 'POST',
            data: 'task=getUser'
        })
        .done(function (data, textStatus, jqXHR) {

            response = JSON.parse(data);

            $("#ask-question-email").val(response.email);
        })
        .fail();

        $(".ask-question-modal").modal();


    });

     $("#city_selection").change(function(e){

            $.ajax('/ajax/product/get_delivery_detail.php', {
                method: 'POST',
                data: 'city='+$(this).val()
            })
            .done(function (data, textStatus, jqXHR) {

                response = JSON.parse(data);

                if(response === 1){
                    $("#delivery-information-1").show();
                    $("#delivery-information-2").hide();
                }
                else if(response === 2){
                    $("#delivery-information-1").hide();
                    $("#delivery-information-2").show();
                }else{
                    $("#delivery-information-1").hide();
                    $("#delivery-information-2").hide();
                }

            })
            .fail();

        });

    $(document).ready(function() {
        $(".delivery-info").on("click",function(){
            hj('trigger','delivery-info');
        });

        $.ajax('/ajax/product/get_campaign.php', {
            method: 'GET',
            dataType: 'json',
            data: 'p_id='+$(".prodid").val()
        })
            .done(function (data, textStatus, jqXHR) {

                if( data.showCampaignPanel && data.content != ''){
                    $('#panel-campaign').show();
                    $('.campaign-list-link').show();
                }

                $('#panel-campaign').find('.panel-body').html(data.content);
                $('.login-link').click(function () {
                    Vivense.loginPopup.open("campaign");
                });
            })
            .fail();

        $.ajax('/integration/testfiyat.php', {
            method: 'GET',
            data: 'sku='+$(".prodid").val()
        })
            .done(function (data, textStatus, jqXHR) {
                $(".testfiyat").html(data);
            })
            .fail();
    });


    $(".open-nearest-showroom").click(function(e){

        $(".nearest-showroom").modal();
        hj('trigger','nearest-showroom');

    });

    var campaignDate = $(".campaign-date").data("date");
    $(".campaign-date")
        .countdown(campaignDate, function(event) {
            $(this).html(
                event.strftime(' ' +'<i></i>'
                                + 'İndirim için son '
                                +'<strong>'
                                +'%D gün %H:%M:%S'
                                +'</strong>')
            );
        });

    $(document).ajaxComplete(function() {
        var fullW =$("#panel-campaign .panel-body .row").find(".fullWidth");
        if(fullW.hasClass("campaing-only-bg-img") || fullW.hasClass("text-only-bg-img") ){
            $("#panel-campaign .panel-body").addClass("no-padding");
        }
    });


    $(".custom-panel .panel-heading").on("click", function () {
        $(this).toggleClass("open");
        $(this).next(".panel-body").stop().slideToggle();
    });
    


    $("#payment-method-link").on("click", function () {

        $("#payment-method").find(".panel-heading").addClass("open");
        $("#payment-method").find(".panel-body").slideDown();
    });

    $("#return-information-link").on("click", function () {

        $("#return-information").find(".panel-heading").addClass("open");
        $("#return-information").find(".panel-body").slideDown();
    });
    $("#guarantee-information-link").on("click", function () {

        $("#guarantee-information").find(".panel-heading").addClass("open");
        $("#guarantee-information").find(".panel-body").slideDown();
    });

    $(".delivery-info").click(function () {
        $("#delivery-information").find(".panel-heading").addClass("open");
        $("#delivery-information").find(".panel-body").slideDown();
    });

    $(".view-in-showroom").click(function () {
        $("#vivense-showroom-tab").find(".panel-heading").addClass("open");
        $("#vivense-showroom-tab").find(".panel-body").slideDown();
    });


    $(".components-change a").on("click", function () {

        $("#component").find(".panel-heading").addClass("open");
        $("#component").find(".panel-body").slideDown();

    });


});
    